import React from 'react';
import ReactMarkdown from 'react-markdown';
import { BookOpen } from 'lucide-react';
import { openGuidePage, remarkGuideCitations } from '../utils/guide';
import { linkifyScreens } from '../utils/screenLinks';
import { ArrowUpRight } from 'lucide-react';

const goScreen = (path) => window.dispatchEvent(new CustomEvent('sabril:navigate', { detail: { path } }));

export const ChatMessageContent = ({ content, testid }) => (
  <div className="text-sm min-w-0 space-y-2 [overflow-wrap:anywhere]" data-testid={testid}>
    <ReactMarkdown
      skipHtml
      remarkPlugins={[remarkGuideCitations]}
      components={{
        p: ({ children }) => <p className="whitespace-pre-wrap">{children}</p>,
        ul: ({ children }) => <ul className="list-disc pl-5 space-y-1">{children}</ul>,
        ol: ({ children }) => <ol className="list-decimal pl-5 space-y-1">{children}</ol>,
        h1: ({ children }) => <p className="font-semibold">{children}</p>,
        h2: ({ children }) => <p className="font-semibold">{children}</p>,
        h3: ({ children }) => <p className="font-semibold">{children}</p>,
        pre: ({ children }) => <pre className="whitespace-pre-wrap break-words">{children}</pre>,
        img: ({ alt }) => <span>{alt}</span>,
        a: ({ href, children, node }) => /^#guide-page-\d+$/.test(href || '') ? (
          <button type="button" onClick={() => openGuidePage(Number(href.split('-').pop()))}
            className="inline text-left align-baseline text-[var(--brand)] underline decoration-dotted underline-offset-4 hover:decoration-solid py-1 max-w-full [overflow-wrap:anywhere] transition-colors"
            data-testid={`${testid}-citation-${node.position?.start.offset ?? node.children?.[0]?.value?.replace(/\D/g, '')}`}>
            <BookOpen size={13} className="inline mr-1" />{children}
          </button>
        ) : /^#screen:\//.test(href || '') ? (
          <button type="button" onClick={() => goScreen(href.slice('#screen:'.length))}
            className="inline-flex items-center gap-0.5 align-baseline font-semibold text-[var(--brand)] underline decoration-dotted underline-offset-4 hover:decoration-solid max-w-full [overflow-wrap:anywhere]"
            data-testid={`${testid}-screen-${node.position?.start.offset}`}>{children}<ArrowUpRight size={12} /></button>
        ) : (
          <a href={href} target="_blank" rel="noopener noreferrer" className="underline"
            data-testid={`${testid}-link-${node.position?.start.offset}`}>{children}</a>
        ),
      }}
    >{linkifyScreens(content || '')}</ReactMarkdown>
  </div>
);